import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { InfiniteResult } from '../_models/body';

@Injectable({
  providedIn: 'root'
})
export class PartnerService {

  constructor(
    private httpClient: HttpClient
  ) { }


  getDevelopers() {
    return this.httpClient.get(`${environment.apiEndpoint}api/Partner/Developer/Query`, { params: { PageSize: -1 } })
  }

  getProducts(params) {
    return this.httpClient.get(`${environment.apiEndpoint}api/Partner/Products/Query`, {
      params: params
    })
  }

  getProductsVersion(params) {
    return this.httpClient.get(`${environment.apiEndpoint}api/Partner/ProductsVersion/Query`, {
      params: params
    })
  }

  updateDeveloper(id, body) {
    return this.httpClient.put(`${environment.apiEndpoint}api/Partner/Developer/${id}`, body)
  }

  updateProduct(id, body) {
    return this.httpClient.put(`${environment.apiEndpoint}api/Partner/Product/${id}`, body)
  }

  updateVersion(id, body) {
    return this.httpClient.put(`${environment.apiEndpoint}api/Partner/ProductVersion/${id}`, body)
  }

  updateVersionStatus(id, actionName, body?) {
    return this.httpClient.put(`${environment.apiEndpoint}api/Partner/ProductVersion/${id}/${actionName}`,
      body ? body : null)
  }

  getContactUs() {
    return this.httpClient.get(`${environment.apiEndpoint}api/Partner/ContactUs/Query`, {
      params: {
        PageSize: '-1',
      }
    })
  }

  getMarkDown() {
    return this.httpClient.get(`${environment.apiEndpoint}api/Md/Query`, {
      params: {
        PageSize: '-1',
      }
    })
  }

  deleteMarkDown(id) {
    return this.httpClient.delete(`${environment.apiEndpoint}api/Md/${id}`)
  }

  addMd(body) {
    return this.httpClient.post(`${environment.apiEndpoint}api/Md/`, body)
  }

  updateMd(id, body) {
    return this.httpClient.put(`${environment.apiEndpoint}api/Md/${id}`, body)
  }

  getModels(params) {
    return this.httpClient.get(`${environment.apiEndpoint}api/Partner/Models/Query`, { params: params })
  }

  getModelsVersion(params) {
    return this.httpClient.get(`${environment.apiEndpoint}api/Partner/ModelsVersion/Query`, {
      params: params
    })
  }

  updateModelVersionStatus(id, actionName, body?) {
    return this.httpClient.put(`${environment.apiEndpoint}api/Partner/ModelVersion/${id}/${actionName}`,
      body ? body : null)
  }

  updateAssetPayId(id, body) {
    return this.httpClient.put(`${environment.apiEndpoint}api/Partner/Asset/${id}`, body)
  }

  getPartnerIncome(developerId?) {
    if (developerId) {
      return this.httpClient.get<InfiniteResult>(`${environment.apiEndpoint}api/Partner/Developer/Income/Query`, {
        params: {
          DeveloperId: developerId,
          PageSize: '-1'
        }
      })
    } else {
      return this.httpClient.get<InfiniteResult>(`${environment.apiEndpoint}api/Partner/Developer/Income/Query`, {
        params: {
          PageSize: '-1'
        }
      })
    }
  }

  sendEmailToReadyToExpire() {
    return this.httpClient.post(`${environment.apiEndpoint}api/Partner/Subscription/SendEmailToReadyToExpire`, null)
  }

  inactiveStageOfPartnerExpired() {
    return this.httpClient.post(`${environment.apiEndpoint}api/Partner/Subscription/InactiveStageOfPartnerExpired`, null)
  }
}
